<script setup>
import { onMounted, onBeforeUnmount } from 'vue';
import './popupTheme.css';

defineProps({
  label: { type: String, required: true },
  toast: { type: String, default: '' },
  fullscreen: { type: Boolean, default: false },
  wide: { type: Boolean, default: false },
});

const emit = defineEmits(['close']);

const onKeydown = e => {
  if (e.key === 'Escape' && !e.defaultPrevented) emit('close');
};
onMounted(() => document.addEventListener('keydown', onKeydown));
onBeforeUnmount(() => document.removeEventListener('keydown', onKeydown));
</script>

<template>
  <Teleport to="body">
    <div
      class="tf-pop tf-backdrop fixed inset-0 z-[9999] flex items-stretch justify-center"
      :class="fullscreen ? '' : 'md:items-center md:p-6'"
      @click.self="emit('close')"
    >
      <div
        class="tf-dialog relative flex flex-col w-full h-full overflow-hidden"
        :class="
          fullscreen
            ? ''
            : [
                'md:rounded-xl',
                wide
                  ? 'md:max-w-[1400px] md:h-[88vh]'
                  : 'md:max-w-[1120px] md:h-auto md:max-h-[92vh]',
              ]
        "
        role="dialog"
        aria-modal="true"
        :aria-label="label"
      >
        <button
          type="button"
          class="tf-close absolute top-3 right-3 z-20"
          title="Fechar (Esc)"
          @click="emit('close')"
        >
          <span class="i-lucide-x size-5" />
        </button>
        <slot />
        <div v-if="toast" class="tf-toast">{{ toast }}</div>
      </div>
    </div>
  </Teleport>
</template>
